import SwitchWrapper from "./switchWrapper.molecule";

export default SwitchWrapper;
